import React, { useContext } from "react";
import styled, { css } from "styled-components";

import Profile from "./Profile";
import Nav from "./Nav";
import Background from "../img/home-background.png";
import BackgroundDarkMode from "../img/home-background--darkmode.png";

import { DarkModeContext } from "./context/DarkModeContext";
import { COLORS, SIZE } from "./common/constants";

const Header = () => {
  return (
    <StyledContainer id="header">
      <Nav></Nav>
      <Profile></Profile>
    </StyledContainer>
  );
};

export default Header;

// 🎨 Styled Components
const StyledContainer = styled.div`
	width: 85%;
	height: 100vh;
	margin: 0 auto;
	padding: 3em 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	${(props) =>
    props.isDarkModeOn &&
    css`
      background-image: url(${BackgroundDarkMode});
    `}

	@media (max-width: ${SIZE.small}) {
		width: 90%;
		padding: 0;
	}
`;
